import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { PRODUCTS, OFFICES } from "../data/content";

export const Footer = () => (
  <footer className="border-t border-slate-200 bg-slate-900 text-slate-300" data-testid="site-footer">
    <div className="container-x grid gap-10 py-14 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <Logo light />
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
          A product-led technology company building software for transport,
          communication, learning and heavy equipment operations — backed by
          enterprise consulting and integration expertise.
        </p>
      </div>
      <nav aria-label="Products">
        <h3 className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">Products</h3>
        <ul className="mt-4 space-y-2.5 text-sm">
          {PRODUCTS.map((p) => (
            <li key={p.id}>
              <Link to={p.path} className="transition-colors hover:text-white" data-testid={`footer-product-${p.id}`}>
                {p.name}
              </Link>
            </li>
          ))}
          <li>
            <Link to="/products" className="text-blue-400 transition-colors hover:text-blue-300" data-testid="footer-all-products">
              Products overview
            </Link>
          </li>
        </ul>
      </nav>
      <nav aria-label="Company">
        <h3 className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">Company</h3>
        <ul className="mt-4 space-y-2.5 text-sm">
          <li><Link to="/consulting" className="transition-colors hover:text-white" data-testid="footer-consulting">Consulting &amp; Solutions</Link></li>
          <li><Link to="/customers" className="transition-colors hover:text-white" data-testid="footer-customers">Customers</Link></li>
          <li><Link to="/insights" className="transition-colors hover:text-white" data-testid="footer-insights">Insights</Link></li>
          <li><Link to="/about" className="transition-colors hover:text-white" data-testid="footer-about">About Us</Link></li>
          <li><Link to="/team" className="transition-colors hover:text-white" data-testid="footer-team">Team</Link></li>
          <li><Link to="/contact" className="transition-colors hover:text-white" data-testid="footer-contact">Get in Touch</Link></li>
        </ul>
      </nav>
      <nav aria-label="Legal">
        <h3 className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">Legal</h3>
        <ul className="mt-4 space-y-2.5 text-sm">
          <li><Link to="/privacy" className="transition-colors hover:text-white" data-testid="footer-privacy">Privacy Policy</Link></li>
          <li><Link to="/terms" className="transition-colors hover:text-white" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
        </ul>
        <p className="mt-6 text-xs leading-relaxed text-slate-500">
          We don't publish phone numbers or email addresses — every enquiry
          reaches us through the contact form.
        </p>
        <div className="mt-5 space-y-3" data-testid="footer-offices">
          {OFFICES.map((o) => (
            <a
              key={o.label}
              href={o.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-xs leading-relaxed text-slate-500 transition-colors hover:text-slate-300"
              data-testid={`footer-office-${o.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              {o.label}: {o.lines.join(" ")}{" "}
              <span className="text-slate-400 underline">Map</span>
            </a>
          ))}
        </div>
      </nav>
    </div>
    <div className="border-t border-slate-800">
      <div className="container-x flex flex-col gap-2 py-5 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
        <span>© 2026 ZasyaOnline Pvt Ltd. All rights reserved.</span>
        <span className="font-mono tracking-wider">MoveOS · myBantu · LearnSphere · CraneSoftwares</span>
      </div>
    </div>
  </footer>
);
